<h2 mat-dialog-title>{{ data?.title || 'Enter the Value' }}</h2>
<div mat-dialog-content class="simple-input-dialog">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>{{ data?.label || 'Name' }}</mat-label>
    <input
      #nameInput
      matInput
      type="text"
      [placeholder]="data?.placeholder || 'Enter a name'"
      [value]="data?.value || ''" />
  </mat-form-field>

  <div class="actions">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="!nameInput.value.trim()"
      (click)="onSendValue(nameInput.value)"
    >
      Accept
    </button>
  </div>
</div>
